import { useZero } from "@rocicorp/zero/react";
import { nanoid } from "nanoid";
import { getInitialConnectorValues } from "../../shared/connectors/getInitialConnectorValues";
import { sharedMutators } from "../../shared/mutators";
import { useRenderWithPlaceholders } from "../components/ConnectorModal/renderWithPlaceholders";
import type { ConnectorConfig } from "../lib/connectorDirectory";
import { useDefaultConnectorGrants } from "./useDefaultConnectorGrants";
import { useHasAccess } from "./useHasAccess";

export function useCreateConnector() {
  const z = useZero();
  const renderWithPlaceholders = useRenderWithPlaceholders();
  const canCreate = useHasAccess("tenant:connected_app_create");
  const grants = useDefaultConnectorGrants();
  const create = (config: ConnectorConfig) => {
    const id = nanoid(12);
    const initialValues = getInitialConnectorValues(
      config.definition,
      renderWithPlaceholders
    );
    z.mutate(
      sharedMutators.createConnectedApp({
        connectedAppId: id,
        name: initialValues.name,
        identifier: config.identifier,
        urlPattern: initialValues.urlPattern,
        configuration: initialValues.configuration,
        secrets: {},
        createOAuthConnection: initialValues.createOAuthConnection,
        grants,
      })
    );
    return id;
  };
  return { canCreate, create };
}
